import { createReducer } from '@reduxjs/toolkit';
import { AsyncStatus } from 'lib-shared-types-api';

import { knowledgeActions } from './knowledge.actions';

type KnowledgeState = {
  smartConversationReply: {
    status: AsyncStatus;
    message: string | null;
  };
};
const initialKnowledgeState: KnowledgeState = {
  smartConversationReply: {
    status: 'uninitialized',
    message: null,
  },
};

export const knowledgeReducer = createReducer(
  initialKnowledgeState,
  (builder) => {
    builder.addCase(
      knowledgeActions.smartConversationResponseRequested,
      (state) => {
        state.smartConversationReply = {
          status: 'pending',
          message: null,
        };
      },
    );
    builder.addCase(
      knowledgeActions.smartConversationResponseReceived,
      (state, action) => {
        state.smartConversationReply = {
          status: 'fulfilled',
          message: action.payload.message,
        };
      },
    );
    builder.addCase(
      knowledgeActions.smartConversationResponseError,
      (state) => {
        state.smartConversationReply.status = 'rejected';
      },
    );
  },
);
